import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//Include Both Helper File with needed methods
import {
	getTransferTypeList as getTransferTypeListApi,
	getTransferType as getTransferTypeApi,
	addNewTransferType as addNewTransferTypeApi,
	updateTransferType as updateTransferTypeApi,
	deleteTransferType as deleteTransferTypeApi,
	existsTransferType as existsTransferTypeApi,
	getTransferTypeListByCompany as getTransferTypeListByCompanyApi
} from '../../helpers/transfer/backend_helper';

export const getTransferTypeList = createAsyncThunk('transferCompanies/getTransferTypeList', async () => {
	try {
		const response = getTransferTypeListApi();
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const getTransferTypeListByCompany = createAsyncThunk('transferCompanies/getTransferTypeListByCompany', async (transfer_company_id) => {
	try {
		const response = getTransferTypeListByCompanyApi(transfer_company_id);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const getTransferType = createAsyncThunk('transferCompanies/getTransferType', async transferType_id => {
	try {
		const response = getTransferTypeApi(transferType_id);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const existsTransferType = createAsyncThunk('transferCompanies/existsTransferType', async rut => {
	try {
		const response = existsTransferTypeApi(rut);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const addNewTransferType = createAsyncThunk('transferCompanies/addNewTransferType', async transferType => {
	try {
		const response = addNewTransferTypeApi(transferType);
		toast.success('Empresa de Transporte agregada exitosamente.', { autoClose: 3000 });
		return response;
	} catch (error) {
		toast.error('Error al agregar transferType.', { autoClose: 3000 });
		throw new Error(error);
	}
});

export const updateTransferType = createAsyncThunk('transferCompanies/updateTransferType', async (transferType) => {
		try {
			const response = updateTransferTypeApi(transferType);
			toast.success('Empresa de Transporte actualizada exitosamente', { autoClose: 3000 });
			return response;
		} catch (error) {
			toast.error('Error al actualizar transferType.', { autoClose: 3000 });
			throw new Error(error);
		}
	}
);

export const deleteTransferType = createAsyncThunk('transferCompanies/deleteTransferType', async transferType => {
	try {
		const response = await deleteTransferTypeApi(transferType);
		toast.success('Empresa de Transporte eliminada exitosamente.', { autoClose: 3000 });
		return { transferType, ...response };
	} catch (error) {
		toast.error('Error al eliminar transferType.', { autoClose: 3000 });
		throw new Error(error);
	}
});
